import { useState, useCallback } from 'react';

export interface ICompanyInfoForm {
  name: string;
  email: string;
  phoneNumber: string;
  address: string;
  website: string;
  country: string;
}

export function useCompanySettingsForm(initialData?: Partial<ICompanyInfoForm>) {
  const [form, setForm] = useState<ICompanyInfoForm>({
    name: initialData?.name ?? '',
    email: initialData?.email ?? '',
    phoneNumber: initialData?.phoneNumber ?? '',
    address: initialData?.address ?? '',
    website: initialData?.website ?? '',
    country: initialData?.country ?? '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const setField = useCallback(
    <K extends keyof ICompanyInfoForm>(key: K, value: ICompanyInfoForm[K]) => {
      setForm(prev => ({ ...prev, [key]: value }));
    },
    []
  );

  const resetForm = useCallback((data?: Partial<ICompanyInfoForm>) => {
    setForm({
      name: data?.name ?? '',
      email: data?.email ?? '',
      phoneNumber: data?.phoneNumber ?? '',
      address: data?.address ?? '',
      website: data?.website ?? '',
      country: data?.country ?? '',
    });
  }, []);

  return { form, setField, resetForm, isSubmitting, setIsSubmitting };
}
